/**
 * @fileoverview Theme context definition
 * @module shared/contexts/ThemeContext
 */

import { createContext } from 'react'

export type Theme = 'dark'

export interface ThemeProviderContextType {
  theme: Theme
  setTheme: (theme: Theme) => void
}

export const ThemeProviderContext = createContext<ThemeProviderContextType | undefined>(undefined)
